// extracted by mini-css-extract-plugin
export default {"invalidBorder":"TagInput_invalidBorder__tvA8o"};